/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rd_trim = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trim each line`)
};

const es_rd_trim = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recortar cada línea`)
};

const de_rd_trim = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Zeile trimmen`)
};

const nl_rd_trim = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trim elke regel`)
};

const fr_rd_trim = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer les espaces`)
};

const it_rd_trim = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi spazi da ogni riga`)
};

const pt_br2_rd_trim = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aparar cada linha`)
};

const pt_rd_trim = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aparar cada linha`)
};

const ja_rd_trim = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各行をトリム`)
};

const zh_rd_trim = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`去除每行首尾空格`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rd_trim = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rd_trim(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rd_trim", locale)
	if (locale === "en") return en_rd_trim(inputs)
	if (locale === "es") return es_rd_trim(inputs)
	if (locale === "de") return de_rd_trim(inputs)
	if (locale === "nl") return nl_rd_trim(inputs)
	if (locale === "fr") return fr_rd_trim(inputs)
	if (locale === "it") return it_rd_trim(inputs)
	if (locale === "pt-BR") return pt_br2_rd_trim(inputs)
	if (locale === "pt") return pt_rd_trim(inputs)
	if (locale === "ja") return ja_rd_trim(inputs)
	return zh_rd_trim(inputs)
};